import ContactUsForm from "./ContactUsForm";

export default function OurStory() {
    return (
      <div className="container mx-auto px-4 py-8 max-w-6xl mt-8">
        <header className="text-center mb-12">
          <h1 className="text-3xl font-bold mb-2">THIS IS OUR STORY</h1>
          <p className="text-gray-600 mb-4">Build Trust With Potential Customers By Providing Background On Dermarays.</p>
          <div className="w-24 h-1 bg-colorPrimary mx-auto"></div>
        </header>
  
        <div className="text-3xl font-semibold text-center mb-8">
        At <span className="text-colorPrimary">Derma Rays Pvt Ltd,</span>  we transform dreams into reality
        </div>
  
        <div className="flex flex-col md:flex-row gap-8 my-16 p-4">
  {/* Mission Section */}
  <div className="flex-1 bg-gradient-to-br from-teal-100 via-white to-blue-100 p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
    <h3 className="text-3xl text-center font-extrabold text-teal-700 mb-6">
      MISSION
    </h3>
    <p className="text-gray-600 text-lg leading-relaxed">
      To empower individuals and professionals with cutting-edge dermatological and cosmetological solutions that enhance well-being, beauty, and confidence. We are dedicated to advancing the field through innovation, collaboration, and a commitment to excellence in service, all while fostering an ecosystem of sustainable growth.
    </p>
  </div>

  {/* Vision Section */}
  <div className="flex-1 bg-gradient-to-br from-purple-100 via-white to-pink-100 p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
    <h3 className="text-3xl text-center font-extrabold text-purple-700 mb-6">
      VISION
    </h3>
    <p className="text-gray-600 text-lg leading-relaxed">
      To be a global leader in dermatological and aesthetic solutions, setting new standards for quality, innovation, and transformative outcomes. We envision a future where technology and human touch harmonize to create sustainable, impactful solutions for a healthier, more beautiful world.
    </p>
  </div>
</div>

  
        <div className="bg-gray-100 p-8 rounded-lg">
          <h2 className="text-2xl font-bold text-center mb-6 text-colorPrimary">OUR TEAM</h2>
          <div className="md:w-4/5 mx-auto my-5">
          <p className="text-center text-sm text-gray-600 mb-8">
            We Experience And Assemble Team Of Diverse Medical Experts To Offer Comprehensive And Effective Solutions That Have A Blend Of Strategic, Operational And Financial
            Expertise. The Management Has Relevant Experience Of More Than 20 Years In These Verticals Enabling Value Expertise And Long Established
            Relationships With Associates.
          </p>
          </div>
          <div className="flex flex-wrap justify-center gap-8 my-6">
            {[1, 2, 3, 4].map((member) => (
              <div key={member} className="w-40 text-center">
                <div className=" mx-auto mb-4 rounded-full overflow-hidden border-4 border-colorPrimary">
                  <img
                    src={`/OurStory/${member}.png`}
                    alt={`Team member ${member}`}
                    className="w-full h-full object-cover"
                  />
                  
                </div>
                <h3 className="text-colorPrimary">Employee1</h3>
                <p>Position</p>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-8 my-16 p-4">
  {/* Core Values Section */}
  <div className="flex-1 bg-gradient-to-br from-blue-100 via-white to-purple-100 p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform ">
    <h3 className="text-3xl text-center font-extrabold text-purple-700 mb-6">
      OUR CORE VALUES
    </h3>
    <p className="text-gray-600 text-lg leading-relaxed space-y-4">
      <strong className="text-purple-800">Innovation:</strong> Embracing new technologies to lead industry advancements.
      <br />
      <strong className="text-purple-800">Excellence:</strong> Delivering quality with precision in every service.
      <br />
      <strong className="text-purple-800">Collaboration:</strong> Working together to achieve more.
      <br />
      <strong className="text-purple-800">Integrity:</strong> Upholding transparency and accountability.
      <br />
      <strong className="text-purple-800">Sustainability:</strong> Prioritizing environmental and social responsibility.
      <br />
      <span className="font-semibold text-lg text-purple-700 block mt-4">What Sets Us Apart</span>
      Derma Rays Pvt Ltd is driven by a talented, diverse team committed to excellence and innovation, creating a culture that celebrates partnership and achievement.
    </p>
  </div>

  {/* Expertise Section */}
  <div className="flex-1 bg-gradient-to-br from-green-100 via-white to-blue-100 p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform ">
    <h3 className="text-3xl text-center font-extrabold text-green-700 mb-6">
      OUR EXPERTISE
    </h3>
    <p className="text-gray-600 text-lg leading-relaxed space-y-4">
      We offer cutting-edge dermatological and cosmetology solutions trusted by professionals. Our commitment to quality is evident in our products and client partnerships.
      <br />
      <span className="font-semibold text-lg text-green-700 block mt-4">A Future of Possibilities</span>
      Guided by expertise and vision, we’re shaping a sustainable, impactful future in dermatology and cosmetology.
    </p>
  </div>
</div>



<ContactUsForm/>










      </div>
    )
  }